import { Pipe, PipeTransform } from '@angular/core';
import type { SectionColumnViewModel } from '../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import type { SectionRowViewModel } from '../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import type { Section } from '../../../../../models/menu/section/section';
import type { ProductMenu } from '../../../../../models/menu/product-menu';

@Pipe({
  name: 'shouldInflateColumnForRow',
  standalone: false
})
export class ShouldInflateColumnForRowPipe implements PipeTransform {
  transform(menu: ProductMenu, section: Section, colVm: SectionColumnViewModel, rowVm: SectionRowViewModel): boolean {
    return menu?.getShouldInflateColumnForRow(section, colVm, rowVm);
  }
}
